import { addOpacityToThemeColor } from '@/utils/styles/addOpacity';
import { useTheme } from '@mui/material';

export const SecureIconImage = () => {
    const theme = useTheme();
    const stroke = theme.colors.palette.tertiary.main;
    const background = addOpacityToThemeColor(stroke, 0.2);

    return (
        <svg
            width="47"
            height="51"
            viewBox="0 0 47 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.9524 46.0677L23.9503 46.0686L22.0207 46.9018L20.0841 45.9775C20.0721 45.9718 20.0599 45.9663 20.0477 45.961C15.2956 43.9222 11.1922 40.6218 8.18195 36.4174C5.17169 32.213 3.3694 27.265 2.97038 22.1095L2.97034 22.109L1.82578 7.41608C1.81972 7.04282 1.93916 6.67808 2.16529 6.38054C2.39576 6.07729 2.72314 5.86213 3.09294 5.77088L3.09294 5.77088L3.09653 5.76998L21.9973 1.03162L40.8985 5.87536L40.8984 5.8754L40.9071 5.87754C41.2769 5.9688 41.6043 6.18395 41.8348 6.4872C42.0609 6.78474 42.1803 7.14947 42.1743 7.52271L41.0297 22.2157L41.0297 22.2162C40.6306 27.3717 38.8284 32.3197 35.8181 36.524C32.8078 40.7284 28.7044 44.0288 23.9524 46.0677Z"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.3256 51L27.7083 49.9867C32.7037 47.8759 37.0173 44.459 40.1817 40.1062C43.3461 35.7534 45.2407 30.6308 45.6601 25.2933L46.8244 10.5733C46.8425 9.96417 46.6481 9.36731 46.2737 8.88212C45.8992 8.39692 45.3674 8.05267 44.7666 7.90667L25.3256 3L5.88457 7.8C5.2838 7.946 4.75193 8.29026 4.37752 8.77545C4.0031 9.26065 3.80872 9.85751 3.82674 10.4667L4.99104 25.1867C5.4105 30.5241 7.30508 35.6468 10.4695 39.9995C13.6339 44.3523 17.9475 47.7692 22.9428 49.88L25.3256 51Z"
                fill={background}
            />
            <path
                d="M14 21.3333L19.3334 26.6667L30 16"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
